import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { renderRoutes } from "react-router-config"
import { HashRouter as Router } from "react-router-dom"
import routes from "./Routes"
import { Provider } from "react-redux"
import "./styles/global.css"
import store from "./store"
// import VConsole from "vconsole"

// new VConsole()

const App = () => (
  <Provider store={store}>
    <Router>
      <Suspense fallback={<div />}>{renderRoutes(routes)}</Suspense>
    </Router>
  </Provider>
)

ReactDOM.render(<App />, document.getElementById("root"))
